module.exports = __webpack_public_path__ + "media/images/carousel/banner_8-962a64ef7459697d3f159f4db306c7bf.jpg";